module.exports = __webpack_public_path__ + "static/media/ItemInvenOpn.dda25c26.xlsx";